
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { requiredBoolean } from './required-boolean.validator';

export function getCreateReservationtypeDtoFormGroup() {
return new FormGroup({
    containertypeId: new FormControl<number | undefined>(undefined, [Validators.required]),
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(100)]),
    description: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(250)]),
    additionalInfotext: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(250)]),
    durationInMinutes: new FormControl<number | undefined>(undefined, [Validators.required]),
    active: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
    minDaysInAdvance: new FormControl<number | undefined>(undefined, [Validators.required]),
    maxDaysInAdvance: new FormControl<number | undefined>(undefined, [Validators.required]),
})
;
}
      